<template>
    <div>
        <van-uploader :multiple="limit !== 1" :max-count="limit" :accept="imgType.join(',')" v-model="fileList"
            :style="bindStyle" :before-read='asyncBeforeRead' :after-read="afterRead" :deletable="false"
            :class="isPreview ? 'preview-class' : ''">
            <template #preview-cover="{ url, status }">
                <template v-if="status !== 'success'">
                </template>
                <template v-else>
                    <template v-if="validFileType(url) === 'image'">
                        <img :src="url" class="upload-image" @click.stop="onViewImgs(url)" />
                    </template>
                    <template v-if="validFileType(url) === 'video'">
                        <video controls class="upload-image">
                            <source :src="url" type="video/mp4" />
                            <source :src="url" type="video/ogg" />
                            您的浏览器不支持Video标签。
                        </video>
                    </template>
                </template>
                <div class="delete-box" @click.stop="handleRemove(url)">
                    <van-icon :name="require('@/assets/images/common/remove-file.png')" size="4.5vw" />
                </div>
            </template>
            <div class="upload-empty">
                <slot name="empty">
                    <div class="empty-box">
                        <van-icon :name="require('@/assets/images/common/add-file.png')" size="4vw" />
                        <div class="empty-text">{{ emptyTitle }}</div>
                    </div>
                </slot>
            </div>
        </van-uploader>
    </div>
</template>
<script>
import { uploadOther } from "@/api/index";

import Vue from "vue";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import { Toast } from 'vant';
Vue.use(Toast);
Vue.use(VueViewer);

// import Compressor from "compressorjs";
const imageType = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
const videoType = ['mp4', 'm2v', 'mkv', 'mov', '3gp']

export default {
    name: "UploadImgs",
    props: {
        // 上传的文件
        fileStr: {
            type: String,
            default: ''
        },
        // 是否是预览 不显示上传
        isPreview: {
            type: Boolean,
            default: false
        },
        // 上传标题
        emptyTitle: {
            type: String,
            default: '上传'
        },
        // 上传
        limit: {
            type: Number,
            default: 20
        },
        // 上传文件格式限制
        fileType: {
            type: Array,
            default: () => (['image/jpeg', 'image/jpg', 'image/png', 'image/gif'])
        },
        // 文件大小 M
        fileSize: {
            type: Number,
            default: 100
        },
        // 是否可以上传视频
        isUploadVideo: {
            type: Boolean,
            default: false
        },
        // 上传 height
        height: {
            type: Number,
            default: 90
        },
        // 上传 width
        width: {
            type: Number,
            default: 90
        },
        // view 间隔
        margin: {
            type: Number,
            default: 8
        },
        // 上传 borderRadius
        borderRadius: {
            type: Number,
            default: 8
        },
    },
    data() {
        return {
            fileList: []
        };
    },
    computed: {
        bindStyle() {
            const px2vw = (px) => `${(px / 462 * 100)}vw`
            return {
                '--width': px2vw(this.width),
                '--height': px2vw(this.height),
                '--borderRadius': px2vw(this.borderRadius),
                '--margin': px2vw(this.margin)
            }
        },
        imgType() {
            const videoType = [
                'video/mp4',
                'video/m2v',
                'video/mkv',
                'video/mov',
                'video/3gp',
                'video/quicktime'
            ]
            return this.isUploadVideo ? this.fileType.concat(videoType) : this.fileType
        }
    },
    methods: {
        asyncBeforeRead(files) {
            const list = Array.isArray(files) ? files : [files]
            const length = this.fileList.length
            // 文件格式 大小校验
            const result = (list.slice(0, this.limit - length)).map((file) => {
                return new Promise((resolve, reject) => {
                    const { size, type } = file

                    if (size / 1024 / 1024 > this.fileSize) {
                        Toast(`上传图片大小不能超过 ${this.fileSize}M！`)
                        reject()
                    }
                    if (!(this.imgType.includes(type.toLocaleLowerCase()))) {
                        Toast(`上传文件不符合所需的格式！`)
                        reject()
                    }
                    // bug 压缩后上传后台后缀名不见了
                    // new Compressor(file, {
                    //     success: (value) => resolve(value),
                    //     error(err) {
                    //         console.log(err.message);
                    //     },
                    // });
                    resolve(file)
                })
            })
            return Promise.all(result)
        },
        async afterRead(fileList) {
            const cloneFileList = fileList.map(item => ({ ...item }))
            const list = cloneFileList.map((file, index) => {
                return new Promise((resolve, reject) => {
                    // 加定时器 后台报错快速点击
                    setTimeout(async () => {
                        try {
                            fileList[index].status = "uploading";
                            fileList[index].message = "上传中...";
                            let formData = new FormData();

                            formData.append("file", file.file);
                            formData.append("module", "efficacy");
                            formData.append("category", "track");
                            formData.append('async', 'false') // 正式环境 接口返回慢了

                            const { data } = await uploadOther(formData)
                            fileList[index].status = "success";
                            fileList[index].message = "上传成功";
                            fileList[index].url = data.absoluteUrl;
                            resolve({ url: data.absoluteUrl })
                        } catch (error) {
                            console.log(error)
                            fileList[index].status = "failed";
                            fileList[index].message = "上传失败";
                            reject({ url: '' })
                        }
                    }, index * 500)
                })
            })
            try {
                await Promise.all(list)
            } catch (error) {
                this.$emit('update:fileStr', '')
            } finally {
                const imgsStr = this.fileList.filter(item => !!item.url).map(item => item.url).join(',')
                this.$emit('update:fileStr', imgsStr)
            }

        },
        validFileType(url = '') {
            const urlName = url.split('.').pop()?.toLocaleLowerCase() || ''
            if (imageType.includes(urlName)) return 'image'
            if (videoType.includes(urlName)) return 'video'
            else return ''
        },
        handleRemove(url) {
            const imgsStr = this.fileList.filter(item => item.url !== url).map(item => item.url).join(',')
            this.$emit('update:fileStr', imgsStr)
        },
        onViewImgs(url) {
            let initialViewIndex = -1
            const images = this.fileList.map((item, index) => {
                if (item.url === url) {
                    initialViewIndex = index
                }
                return item.url
            })
            this.$viewerApi({
                images,
                options: {
                    zIndex: 99999,
                    title: false,
                    initialViewIndex,
                },
            });
        },
    },
    watch: {
        fileStr: {
            handler(value) {
                const list = (value ? value.split(',') : []).map(item => ({
                    url: item,
                    status: 'success',
                    message: '上传成功'
                }))
                this.fileList = list
            },
            immediate: true
        }
    }
};
</script>
<style scoped lang="scss">
:deep(.van-uploader) {
    .van-uploader__preview {
        background-color: #F8F9FF;
        width: var(--width);
        height: var(--height);
        border-radius: var(--borderRadius);
        margin-right: var(--margin);
        margin-bottom: var(--margin);
    }

    .van-uploader__preview-image {
        background-color: #F8F9FF;
        width: var(--width);
        height: var(--height);
        border-radius: var(--borderRadius);
        overflow: visible;
    }

    .van-uploader__input-wrapper {
        background-color: #F8F9FF;
        width: var(--width);
        height: var(--height);
        border-radius: var(--borderRadius);
    }

    .upload-empty {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .empty-box {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            font-size: 14px;
            color: #999;
            flex-direction: column;
            line-height: normal;

            .empty-text {
                margin-top: 9px;
            }
        }
    }

    .upload-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: var(--borderRadius);
    }

    .delete-box {
        z-index: 1;
        position: absolute;
        top: -6px;
        right: -6px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .van-uploader__mask {
        border-radius: var(--borderRadius);
    }

    .van-image__img,
    .van-uploader__file-name,
    .van-uploader__file-icon {
        display: none;
    }

    &.preview-class {
        .van-uploader__input-wrapper {
            display: none;
        }

        .delete-box {
            display: none;
        }
    }
}
</style>